export default __webpack_public_path__ + "static/media/bg-top.7250bd32.webp";